import { render, staticRenderFns } from "./manageSourceModal.vue?vue&type=template&id=e166d032&scoped=true&"
import script from "./manageSourceModal.vue?vue&type=script&lang=js&"
export * from "./manageSourceModal.vue?vue&type=script&lang=js&"
import style0 from "./manageSourceModal.vue?vue&type=style&index=0&id=e166d032&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e166d032",
  null
  
)

export default component.exports